import React from 'react';
import { observer } from 'mobx-react-lite';
import GenericModal from '../../../shared/generic-modal/generic-modal';
import WarningIcon from '@svg/warning.svg?react';
import { upperFirst } from 'lodash';

export interface DependenciesWarningModalProps {
    appName: string;
    dependentApps?: string[];
    okCallback: () => void;
    open?: boolean;
    setOpen?: (open: boolean) => void;
    action: 'allow' | 'block' | 'remove';
}

export const DependenciesWarningModal: React.FC<DependenciesWarningModalProps> = observer(({
    dependentApps,
    appName,
    okCallback,
    open,
    setOpen,
    action
}) => {

    const text = action === 'allow' ? `To allow ${appName}, the following dependent apps must be allowed as well:`
        : `If you ${action} ${appName}, the following allowed apps might no longer be accessible:`;
    const body = (
        <>
            <div className="modal-commit-message">{text}</div>
            <div className="modal-small-commit-message">
                {
                    dependentApps?.map(app =>
                        <div key={app} className="dependent-app">{app}</div>)}
            </div>
        </>
    );

    const buttons = [
        {
            text: 'Cancel',
            onClick: () => setOpen?.(false),
            className: 'secondary-btn'
        },
        {
            text: action === 'allow' ? 'Allow All' : upperFirst(action),
            onClick: okCallback,
            className: 'primary-btn'
        }
    ];

    return (
        <GenericModal
            open={open}
            title={action === 'allow' ? 'Allow Dependent Apps?' : 'Important'}
            body={body}
            actionButtons={buttons}
            onCancel={() => setOpen?.(false)}
            wrapClassName="modal-confirm-message-wrapper"
            icon={action !== 'allow' ? <span className="warning-icon"><WarningIcon /></span> : null}
            closable={false}
        />
    );
});